import { render } from "./BookingPage.vue?vue&type=template&id=f2365c56&ts=true"
import script from "./BookingPage.vue?vue&type=script&lang=ts"
export * from "./BookingPage.vue?vue&type=script&lang=ts"

import "./BookingPage.vue?vue&type=style&index=0&id=f2365c56&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__